<template>
  <spinner :size="20" line-fg-color="#5ad691" />
</template>

<script>
import Spinner from 'vue-simple-spinner'

export default {
  name: 'LoaderChip',
  components: { Spinner }
}
</script>
